import { Doughnut } from 'vue-chartjs'
import chartMixin from './chartMixin'

export default {
  mixins: [Doughnut, chartMixin],
}
